import axios from 'axios';

export default function setCompanyStatus({
  id,
  status,
  remarks,
}) {
  return new Promise((resolve, reject) => axios
    .put(`/account/system-admin/api/v1/company/${id}/status`, {
      status, remarks
    })
    .then((response) => resolve(response.data))
    .catch((error) => reject(error.message)));
}
